module.exports = __webpack_public_path__ + "static/media/schema_uhli.bad6c700.png";